import { makeRequest } from '../client';

export const joinTableSession = (data) => makeRequest('tableSession', 'join', data);
export const getTableSession = (data) => makeRequest('tableSession', 'get', data);
export const claimTableSessionIdentity = (data) => makeRequest('tableSession', 'claimIdentity', data);
export const recoverTableSession = (data) => makeRequest('tableSession', 'recover', data);
export const getMyActiveTableSessions = () => makeRequest('tableSession', 'getMyActiveSessions');
export const resumeMyTableSession = (data) => makeRequest('tableSession', 'resumeMySession', data);
export const syncTableDraft = (data) => makeRequest('tableSession', 'syncMyDraft', data);
export const submitTableRound = (data) => makeRequest('tableSession', 'submitRound', data);
export const requestTableSettlement = (data) => makeRequest('tableSession', 'requestSettlement', data);
export const removeTableParticipant = (data) => makeRequest('tableSession', 'removeParticipant', data);
